// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFeeReversalCreateDto
 */
export interface IFeeReversalCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IFeeReversalCreateDto
     */
    fee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeReversalCreateDto
     */
    fee_modification_id?: number;
}

/**
 * Check if a given object implements the IFeeReversalCreateDto interface.
 */
export function instanceOfIFeeReversalCreateDto(value: object): value is IFeeReversalCreateDto {
    return true;
}

export function IFeeReversalCreateDtoFromJSON(json: any): IFeeReversalCreateDto {
    return IFeeReversalCreateDtoFromJSONTyped(json, false);
}

export function IFeeReversalCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFeeReversalCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fee_id': json['fee_id'] == null ? undefined : json['fee_id'],
        'fee_modification_id': json['fee_modification_id'] == null ? undefined : json['fee_modification_id'],
    };
}

export function IFeeReversalCreateDtoToJSON(json: any): IFeeReversalCreateDto {
    return IFeeReversalCreateDtoToJSONTyped(json, false);
}

export function IFeeReversalCreateDtoToJSONTyped(value?: IFeeReversalCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fee_id': value['fee_id'],
        'fee_modification_id': value['fee_modification_id'],
    };
}

